import { PayloadAction } from '@reduxjs/toolkit';
import { DTODiffusionModelsTablePageSettingsUD } from '@shared/dto/+diffusion_model/+ud/table/dto_diffusion_models_table_page_settings_ud';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { diffusion_models_ud_update_current_table_with_settings } from './_methods/diffusion_models_ud_update_current_table_with_settings';
import { StateMLAsset } from './state_ml_asset';

export const local_ml_asset_set_current_table_page_settings = (
  payload: DTODiffusionModelsTablePageSettingsUD,
): PayloadAction<DTODiffusionModelsTablePageSettingsUD> => ({
  type: ENUM__redux_action.ML_ASSET_SET_CURRENT_TABLE_PAGE_SETTINGS,
  payload,
});

export async function init_local_ml_asset_set_current_table_page_settings(state: StateMLAsset, action: PayloadAction<DTODiffusionModelsTablePageSettingsUD>) {
  let page_settings = action.payload.clone();

  state.current_table_page_settings = page_settings;

  await diffusion_models_ud_update_current_table_with_settings(state, page_settings);
}
